const vuexModules = {
    namespaced: true,
    state: {
        useGolfCode: null,
        useGolfName: null,
        reserveNo: 0,
        planName: ''
    },
    mutations: {
        useGolfCode (state, useGolfCode) {
            state.useGolfCode = useGolfCode;
        },
        useGolfName (state, useGolfName) {
            state.useGolfName = useGolfName;
        },
        pushReserveNo (state, pushReserveNo) {
            state.reserveNo = pushReserveNo;
        },
        pushPlanName (state, pushPlanName) {
            state.planName = pushPlanName;
        },
        pushPlayDate (state, pushPlayDate) {
            state.playDate = pushPlayDate;
        }
    }
};

export default vuexModules;
